/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const UpsertDestinationBody = zod
	.object({
		endpoint: zod.url().describe('Webhook endpoint URL'),
		environment_id: zod.string().describe('Environment ID this destination belongs to'),
		events: zod.array(zod.string()).describe('List of event types to subscribe to'),
		type: zod.enum(['webhook', 'callback'])
	})
	.describe('Request body for creating an event destination');

export type UpsertDestinationBody = zod.input<typeof UpsertDestinationBody>;
export type UpsertDestinationBodyOutput = zod.output<typeof UpsertDestinationBody>;
